import Svg from '../assets/svgs/logo-large.svg?react'

export const LoadingScreen = ({ loadingText }: { loadingText?: string }) => {
  return (
    <div className="loading-screen">
      <Svg />
      {loadingText ? <span className="loading-text">{loadingText}</span> : null}
    </div>
  )
}
